import axios from "axios"
// const apiURL =  'http://192.168.0.136/wp-json/yis/v1/' //'http://192.168.33.17/wp-json/yis/v1/' //'http://192.168.0.202/wp-json/yis/v1/'
const apiURL = 'https://www.yachtinteriorsociety.com/wp-json/yis/v1/'

export async function get(path, callback) {

    try {
        var headers = { "Content-Type": "application/json" };
        // console.log(NonceSettings.nonce);
        if (window.NonceSettings != null) {
            // console.log(window.NonceSettings.nonce);
            headers = { "Content-Type": "application/json", 'X-WP-Nonce': window.NonceSettings.nonce };
        } else {
            // console.log('no nonce');
            // var headers = { "Content-Type": "application/json", 'X-WP-Nonce': 'xxxxxxxxxxxx' };
        }
        const res = await axios.get(`${apiURL + path}`, { headers });
        // const res = await axios.get(`${apiURL + path}`);
        if (res) {
            // console.log(res);
            if (res.data === null) {
                callback(false, null)
            } else {
                callback(false, res.data)
            }
        }
    } catch (error) {
        callback(error, null)
    }
}

export async function post(path, body, callback) {
    try {
        const res = await axios.post(
            `${apiURL + path}`,
            body
        );
        if (res.data === null) {
            callback(false, null)
        } else {
            callback(false, res.data)
        }
    } catch (error) {
        callback(error, null)
    }
}